<template>
  <div>
    <Header></Header>
    <SubmitSuccessfully></SubmitSuccessfully>
    <Footer></Footer>
  </div>
</template>
<script>
import SubmitSuccessfully from "../../components/submitSuccessfully/index.vue";
export default {
  components: {
    SubmitSuccessfully,
  },
};
</script>
<style lang="scss" scoped>
</style>